module.exports = __webpack_public_path__ + "img/allthat_main_banner_kor100_2.18069230.png";